import UpIcon from './component'

export default UpIcon
